import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo.png'

const Footer = (props) => {
    return (
        <div className="tp-site-footer text-center">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="footer-image">
                            <Link className="logo" to="/"><img src={Logo} alt="" /></Link>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="link-widget">
                            <ul>
                                <li><Link to="https://www.linkedin.com/in/yasser-mj/"><i className="ti-linkedin"></i></Link></li>
                                <li><Link to="https://github.com/yasserMejri"><i className="ti-github"></i></Link></li>
                                <li><Link to="mailto:yassermejri0988@gmail.com"><i className="ti-email"></i></Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="copyright">
                            <p>© 2026. All rights reserved by Yasser Mejri.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;